<template>
  <div class="module-table">
    <el-table :data="paginatedData" border size="small" class="data-table">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="编号" >
            <template slot-scope="scope">
              {{ scope.row.bidding_id || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="中标金额">
            <template slot-scope="scope">
              {{ scope.row.winning_bidder_amount|| '-' }}
            </template>
        </el-table-column>
        <el-table-column label="公告日期">
            <template slot-scope="scope">
              {{ scope.row.bulletin_date|| '-' }}
            </template>
        </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="moduleData.length"
      style="margin-top: 10px; text-align: right;"
    />
  </div>
</template>

<script>
export default {
    name: 'biddingLinkList',
  computed: {
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.moduleData.slice(start, start + this.pageSize);
    }
  },
    data() {
        return {
            currentPage: 1,
            pageSize: 10,
            title: '招投标公告',
        }
    },  
    props: {
        moduleData: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        handleCurrentChange(val) {
            this.currentPage = val;
        },
    }
}
</script>

<style scoped lang="scss">
// 表格铺满
.module-table {
  width: 100%;
  .el-table { 
    width: 100%;
  }
}
</style>